window.ACH_LOCATION_DATA = {
  zones: {
    lima_99: [
      "La Molina", "Santiago de Surco", "San Borja", "San Isidro", 
      "Miraflores", "Barranco", "Surquillo", "La Victoria", 
      "Jesús María", "Pueblo Libre", "San Miguel"
    ],
    lima_nextday: [
      "San Borja", "San Isidro", "Santiago de Surco", 
      "Miraflores", "Barranco", "San Miguel", "Jesús María"
    ],
    lima_hoy: [
      "Barranco", "Bellavista", "Breña", "Callao Cercado", "Carmen de la Legua-Reynoso",
      "Comas", "Cercado de Lima", "Chorrillos", "El Agustino", "Independencia",
      "Jesús María", "La Molina", "La Perla", "La Victoria", "Lince", "Los Olivos",
      "Magdalena del Mar", "Miraflores", "Pueblo Libre", "Rímac", "San Borja",
      "San Isidro", "San Luis", "San Miguel", "San Juan de Lurigancho",
      "San Juan de Miraflores", "Santa Anita", "Santiago de Surco",
      "San Martín de Porres", "Surquillo", "Ate - Vitarte", "Ate - Salamanca", "Mayorazgo"
    ],
    lima_24_48: [
      "Ancón", "Carabayllo", "Chaclacayo", "Cieneguilla", "Ate - Huaycán",
      "Lurigancho - Chosica", "Lurín", "La Punta", "Mi Perú", "Pachacámac",
      "Santa Rosa", "Ate - Santa Clara", "Villa María del Triunfo", "Puente Piedra",
      "Villa El Salvador", "Ventanilla", "Asia", "Aspitia", "Chilca", "San Bartolo",
      "Santa María del Mar", "San Andrés", "Pucusana", "Punta Hermosa", "Punta Negra"
    ]
  },

  messages: {
    lima_nextday: "NEXTDAY: Lima llega antes de las 2pm. L-S Pagos hasta las 4pm.",
    lima_hoy: "Llega HOY Lima Express antes 9pm. L-S Pagos hasta las 4pm.",
    lima_99: "99 Minutos o es GRATIS. L-S de 10am a 4pm.",
    lima_24_48: "Entrega programada en 48H según disponibilidad de ruta.",
    provincia: "Provincias: si pagas antes de la 1:00 p.m., dejamos tu pedido en agencia Shalom/Marvisur el mismo día hábil.",
    unknown: "Elige tu ubicación para ver la cobertura disponible."
  }
};